<template>
  <div>
    <div v-if="status==0" class="container-fluid">
      <h4>Set parameters:</h4>    
      <div class="row my-2">
        <div class="col-sm-1 pt-1">Survey type</div>
        <div class="col-sm-2">
          <select 
            class="form-select"
            :options="surveytypes" 
            v-model="surveytype_id"
            @change="languages_get();normvalues_get();"  
          >
            <option v-for="type in surveytypes" :key="type.value" :value="type.value">
              {{ type.text }}
            </option>
          </select>
        </div>
        <div class="col-sm-1 pt-1">Normvalues</div>
        <div class="col-sm-2">
          <select class="form-select" v-model="normvalues_id">
            <option v-for="norm in normvalues" :key="norm.value" :value="norm.value">
              {{ norm.text }}
            </option>
          </select>
        </div>
        <div class="col-sm-1 pt-1">Language</div>
        <div class="col-sm-2">
          <select class="form-select" v-model="language_id">
            <option v-for="lang in languages" :key="lang.value" :value="lang.value">
              {{ lang.text }}
            </option>
          </select>
        </div>
        <div class="col-sm-3">
          <button @click.prevent="createSurveys" class="btn btn-primary" :disabled="groups.length===0">Create groups and surveys</button>
        </div>           
      </div>
      <h4>Create groups and surveys:</h4>
      <div class="row my-1">
        <div class="col-sm-4">
          Group Name
        </div>
        <div class="col-sm-1">
          Members
        </div>
        <div class="col-sm-1">
          Surveys
        </div>
        <div class="col-sm-2">
          Start date
        </div>
        <div class="col-sm-2">
          Surveys interval months
        </div>
        <div class="col-sm-2">
          <button
            class="btn btn-primary col-8"
            @click.prevent="addGroup"
          >
            <fa-icon
                class="me-2"
                name="plus"
            />Add
          </button>
        </div>      
      </div>
      <div class="row py-2" v-bind:key="group.id" v-for="group in groups">
        <div class="col-sm-4">
          <input
            class="form-control"
            v-model="group.groupName"
          />
        </div>
        <div class="col-sm-1">
          <input
            class="form-control"
            v-model="group.numberMembers"
          />
        </div>
        <div class="col-sm-1">
          <input
            class="form-control"
            v-model="group.numberSurveys"
          />
        </div>
        <div class="col-sm-2">
          <datetime
            format="yyyy-LL-dd"
            v-model="group.startDate"
            value-zone="Europe/Stockholm"
            zone="Europe/Stockholm"
            :phrases="{ok: 'OK', cancel: 'Cancel'}"
          >
          </datetime>
        </div>
        <div class="col-sm-2">
          <input
            class="form-control"
            v-model="group.monthsBetween"
          />
        </div>
        <div class="col-sm-2">
          <button
            class="btn btn-danger col-8"
            @click.prevent="removeGroup(group.id)"
          >
            <fa-icon
                class="me-2"
                name="trash"
            />Remove
          </button>
        </div>
      </div>
    </div>
    <div v-if="status==1" class="container-fluid">
      <h4>Generating testdata...</h4>
    </div>
    <div v-if="status==2" class="container-fluid">
      <h4>Testdata generated</h4>
    </div>
  </div>
</template>
<script>
import Datetime from './CustomControls/Datetime.vue';
import axios from 'axios'
import { config } from '../../config';
const base_url = config.base_url;

export default {
  name: 'GenerateTestData',
  components: {
    Datetime
  },
  created() {
    this.surveytypes_get();
    this.normvalues_get();
    this.languages_get();
  },
  data: function() {
    return {
      status: 0,
      surveytype_id: 1,
      surveytypes: [],
      normvalues_id: 999,
      normvalues: [],
      language_id: 38,
      languages: [],
      groups: [],
    }
  },
  methods: {
    createSurveys() {
      this.status = 1;
      const record = {
        groups: this.groups,
        surveytype_id: this.surveytype_id,
        normvalues_id: this.normvalues_id,
        language_id: this.language_id,
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      return new Promise((resolve) => {
        axios.post(
          base_url+"/gdq_testdata_create",
          JSON.stringify(record), {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
            }
          }
        )
        .then((resp) => {
          this.status = 2;
          resolve(resp);
        })
      });
    },
    addGroup() {
      const id = this.groups.length + 1;
      this.groups.push({
        id: id,
        groupName: `Group ${id}`,
        numberMembers: 3,
        numberSurveys: 3,
        startDate: '2021-01-01',
        monthsBetween: 3,
      });

    },
    removeGroup(id) {
      this.groups = this.groups.filter(g => g.id != id);
    },
    surveytypes_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      return new Promise((resolve) => {
        axios.get(base_url+"/g_surveytypes")
        .then((resp) => {
          this.surveytypes = resp.data.result.map(
            r => { return { value: r.id, text: r.surveytype_name } }
          );
          resolve(resp);
        });                
      });
    },
    normvalues_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      return new Promise((resolve) => {
        axios.get(base_url+"/gdq_normvalues_countries")
        .then((resp) => {
          this.normvalues = resp.data.map(
            r => { return { value: r.country_id, text: r.country_name } }
          );
          resolve(resp);
        });                
      });

    },
    languages_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      let filter = {};
      if (this.surveytype_id == 2) { filter.language_enabled_gdq_short =  { operator: "=", value: 1, }}
      if (this.surveytype_id == 3) { filter.language_enabled_gdq_osc =  { operator: "=", value: 1, }}
      return new Promise((resolve) => {
        axios.get(base_url+"/g_languages?filter="+JSON.stringify(filter))
        .then((resp) => {
          this.languages = resp.data.result.map(
            r => { return { value: r.id, text: r.language_name } }
          );
          resolve(resp);
        });                
      });
    },
  },
}
</script>
<style scoped>

</style>
